import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';    // ← importer
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initGA } from './analytics';

// Initialise GA une seule fois
initGA();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* ← BrowserRouter englobe tout App */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
